__turbopack_context__.v({
  "h2": "new-events-module-scss-module__iNfP8a__h2",
  "imageContainer": "new-events-module-scss-module__iNfP8a__imageContainer",
  "item": "new-events-module-scss-module__iNfP8a__item",
  "list": "new-events-module-scss-module__iNfP8a__list",
});
